export const AI_SCORING_ERROR_MESSAGE =
  "AI scoring failed. Please try again in a moment.";

const SESSION_INVALID_CODE = 501;
const SESSION_INVALID_STATUSES = new Set([401, 419, 440]);
const SESSION_INVALID_PATTERNS = [
  "session expired",
  "session invalid",
  "session expired or not found",
  "account has been blocked",
  "blocked by admin",
];

export const isSessionFailure = ({ status, responseCode, message } = {}) => {
  if (SESSION_INVALID_STATUSES.has(status)) return true;
  if (responseCode === SESSION_INVALID_CODE) return true;
  if (typeof message !== "string") return false;

  const normalizedMessage = message.toLowerCase();
  return SESSION_INVALID_PATTERNS.some((pattern) =>
    normalizedMessage.includes(pattern)
  );
};

export const getAiScoringErrorMessage = (data) => {
  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message;
  }

  if (typeof data?.error === "string" && data.error.trim()) {
    return data.error;
  }

  return AI_SCORING_ERROR_MESSAGE;
};

export const parseAiScoringResponse = async (response) => {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
};

export const isSuccessfulAiScoringResponse = (response, data) =>
  !!response?.ok && !!data && !data.error;

export const handleAiScoringFailure = ({ response, data, logout, navigate } = {}) => {
  const message = data?.message || data?.error;
  const shouldLogout = isSessionFailure({
    status: response?.status,
    responseCode: data?.responseCode,
    message,
  });

  if (shouldLogout) {
    if (typeof logout === "function") {
      logout({ reason: "session-expired" });
    }
    if (typeof navigate === "function") {
      navigate("/login");
    }
    return;
  }

  window.alert(getAiScoringErrorMessage(data));
};
